import { Component, HostBinding } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    // moduleId: module.id,
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})

export class FooterComponent{
    currentDate : Date = new Date();
    constructor(public router:Router){

    }
    onClick(url){
        window.open(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.ts